import React from 'react';
import { Row, Col } from 'react-bootstrap';

import SocialLinks from './SocialLinks';
import PaymentTypes from './PaymentTypes';
import AppLinks from './AppLinks';

const PromotedBlock = () => (
  <div className="Footer-Promoted">
    <Row className="align-items-center">
      <Col md={4} lg={4}>
        <SocialLinks />
      </Col>
      <Col md={1} lg={4}>
        <PaymentTypes />
      </Col>
      <Col md={7} lg={4}>
        <AppLinks />
      </Col>
    </Row>
  </div>
);

export default PromotedBlock;